module.exports = __webpack_public_path__ + "static/media/zamboni.655da73a.mov";